module.exports = __webpack_public_path__ + "4dfb050f24aab52952b4f15bb685f266.pdf";